export function setFilterRegulation(filter) {
    return {
        type: 'SET_FILTER_REGULATION',
        payload: filter,
    }
}

export function setFilterTask(filter) {
    return {
        type: 'SET_FILTER_TASK',
        payload: filter,
    }
}


// WEBPACK FOOTER //
// ./src/redux/actions/filter.js